module.exports = __webpack_public_path__ + "img/design6.fd4a4470.png";